export const WEB_APP_URL = process.env.REACT_APP_WEB_APP_URL;
export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const SUCCESS_OR_ERROR_RESULT = true;

export const MODAL_STEPS = {
  INTRO: { number: 0 },
  INTRO_INFO: { number: 1 },
  INTRO_INFO_FOOT: { number: 2 },
  SCAN_1: { number: 3 },
  SCAN_2: { number: 4 },
  SCAN_RESULT: { number: 5 },
  GENDER_SELECT: { number: 6 },
  SIZE_SELECT: { number: 7 },
  LOADER: { number: 8 },
  RESULT: { number: 9 },
  ERROR: { number: 10 },
};

export const GENDERS = {
  F: "female",
  M: "male",
};

export const BASE_SIZES = [
  {
    name: "EU",
    image: "EU",
    label: "Europe",
    sizes: [
      {
        male: 34.0,
        female: 34.0,
      },
      {
        male: 34.5,
        female: 34.5,
      },
      {
        male: 35.0,
        female: 35.0,
      },
      {
        male: 35.5,
        female: 35.5,
      },
      {
        male: 36.0,
        female: 36.0,
      },
      {
        male: 36.5,
        female: 36.5,
      },
      {
        male: 37.0,
        female: 37.0,
      },
      {
        male: 37.5,
        female: 37.5,
      },
      {
        male: 38.0,
        female: 38.0,
      },
      {
        male: 38.5,
        female: 38.5,
      },
      {
        male: 39.0,
        female: 39.0,
      },
      {
        male: 39.5,
        female: 39.5,
      },
      {
        male: 40.0,
        female: 40.0,
      },
      {
        male: 40.5,
        female: 40.5,
      },
      {
        male: 41.0,
        female: 41.0,
      },
      {
        male: 41.5,
        female: 41.5,
      },
      {
        male: 42.0,
        female: 42.0,
      },
      {
        male: 42.5,
        female: 42.5,
      },
      {
        male: 43.0,
        female: 43.0,
      },
      {
        male: 43.5,
        female: 43.5,
      },
      {
        male: 44.0,
        female: 44.0,
      },
      {
        male: 44.5,
        female: 44.5,
      },
      {
        male: 45.0,
        female: 45.0,
      },
      {
        male: 45.5,
        female: 45.5,
      },
      {
        male: 46.0,
        female: 46.0,
      },
      {
        male: 46.5,
        female: 46.5,
      },
      {
        male: 47.0,
        female: 47.0,
      },
      {
        male: 47.5,
        female: 47.5,
      },
      {
        male: 48.0,
        female: 48.0,
      },
      {
        male: 48.5,
        female: 48.5,
      },
      {
        male: 49.0,
        female: 49.0,
      },
      {
        male: 49.5,
        female: 49.5,
      },
      {
        male: 50.0,
        female: 50.0,
      },
    ],
  },
  {
    name: "US",
    image: "US",
    label: "USA",
    sizes: [
      {
        male: 2.0,
        female: 3.5,
      },
      {
        male: 2.5,
        female: 4.0,
      },
      {
        male: 3.0,
        female: 4.5,
      },
      {
        male: 3.5,
        female: 5.0,
      },
      {
        male: 4.0,
        female: 5.5,
      },
      {
        male: 4.5,
        female: 6.0,
      },
      {
        male: 5.0,
        female: 6.5,
      },
      {
        male: 5.5,
        female: 7.0,
      },
      {
        male: 6.0,
        female: 7.5,
      },
      {
        male: 6.5,
        female: 8.0,
      },
      {
        male: 7.0,
        female: 8.5,
      },
      {
        male: 8.0,
        female: 9.0,
      },
      {
        male: 8.5,
        female: 9.5,
      },
      {
        male: 9.0,
        female: 10.0,
      },
      {
        male: 9.5,
        female: 10.5,
      },
      {
        male: 10.0,
        female: 11.0,
      },
      {
        male: 10.5,
        female: 11.5,
      },
      {
        male: 11.0,
        female: 12.0,
      },
      {
        male: 11.5,
        female: 12.5,
      },
      {
        male: 12.0,
        female: 13.0,
      },
      {
        male: 12.5,
        female: 13.5,
      },
      {
        male: 13.0,
        female: 14.0,
      },
      {
        male: 13.5,
        female: 14.5,
      },
      {
        male: 14.0,
        female: 15.0,
      },
      {
        male: 14.5,
        female: 15.5,
      },
      {
        male: 15.0,
        female: 16.0,
      },
      {
        male: 15.5,
        female: 16.5,
      },
      {
        male: 16.0,
        female: 17.0,
      },
      {
        male: 16.5,
        female: 17.5,
      },
      {
        male: 17.0,
        female: 18.0,
      },
      {
        male: 17.5,
        female: 18.5,
      },
      {
        male: 18.0,
        female: 19.0,
      },
    ],
  },
  {
    name: "UK",
    image: "UK",
    label: "UK",
    sizes: [
      {
        male: 1.5,
        female: 1.0,
      },
      {
        male: 2.0,
        female: 1.5,
      },
      {
        male: 2.5,
        female: 2.0,
      },
      {
        male: 3.0,
        female: 2.5,
      },
      {
        male: 3.5,
        female: 3.0,
      },
      {
        male: 4.0,
        female: 3.5,
      },
      {
        male: 4.5,
        female: 4.0,
      },
      {
        male: 5.0,
        female: 4.5,
      },
      {
        male: 5.5,
        female: 5.0,
      },
      {
        male: 6.0,
        female: 5.5,
      },
      {
        male: 6.5,
        female: 6.0,
      },
      {
        male: 7.0,
        female: 6.5,
      },
      {
        male: 7.5,
        female: 7.0,
      },
      {
        male: 8.0,
        female: 7.5,
      },
      {
        male: 8.5,
        female: 8.0,
      },
      {
        male: 9.0,
        female: 8.5,
      },
      {
        male: 9.5,
        female: 9.0,
      },
      {
        male: 10.0,
        female: 9.5,
      },
      {
        male: 10.5,
        female: 10.0,
      },
      {
        male: 11.0,
        female: 10.5,
      },
      {
        male: 11.5,
        female: 11.0,
      },
      {
        male: 12.0,
        female: 11.5,
      },
      {
        male: 12.5,
        female: 12.0,
      },
      {
        male: 13.0,
        female: 12.5,
      },
      {
        male: 13.5,
        female: 13.0,
      },
      {
        male: 14.0,
        female: 13.5,
      },
      {
        male: 14.5,
        female: 14.0,
      },
      {
        male: 15.0,
        female: 14.5,
      },
      {
        male: 15.5,
        female: 15.0,
      },
      {
        male: 16.0,
        female: 15.5,
      },
      {
        male: 16.5,
        female: 16.0,
      },
      {
        male: 17.0,
        female: 16.5,
      },
    ],
  },
];
